import styled from 'styled-components';

export default styled.text`
  text-anchor: middle;
  fill: ${(p) => p.theme.colors.gray};
`;
